var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"regSucc_page_wrap"},[_c('div',{staticClass:"layout_n"},[_c('div',{staticClass:"reg_succ"},[_c('div',{staticClass:"title"},[_vm._v("注册成功！")]),_vm._v(" "),_c('div',{staticClass:"btn"},[_c('router-link',{attrs:{"to":"/login"}},[_vm._v("前往登录")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-4576bb76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/user/regSucc.vue
// module id = 5EVW
// module chunks = 5